import { render, staticRenderFns } from "./DatasetChartDetail.vue?vue&type=template&id=4940fd0c&scoped=true"
import script from "./DatasetChartDetail.vue?vue&type=script&lang=js"
export * from "./DatasetChartDetail.vue?vue&type=script&lang=js"
import style0 from "./DatasetChartDetail.vue?vue&type=style&index=0&id=4940fd0c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4940fd0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4940fd0c')) {
      api.createRecord('4940fd0c', component.options)
    } else {
      api.reload('4940fd0c', component.options)
    }
    module.hot.accept("./DatasetChartDetail.vue?vue&type=template&id=4940fd0c&scoped=true", function () {
      api.rerender('4940fd0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/common/DatasetChartDetail.vue"
export default component.exports